import styled from 'styled-components';

export const HeaderImageContainer = styled.div`
    width: 100%;
    height: 90vh;
    background-repeat: no-repeat;
    background-position: center top 40%;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: center;
    // position: relative;

    .header-info {
        text-shadow: black 0px 0px 10px;
        text-align: center;
        max-width: 90%;
        display: flex;
        flex-direction: column;
        align-items: center;
        // align-self: center;

        h1 {
           font-size: ${window.screen.width <= 1000 ? '1.9em' : '4em'}; 
           padding: 0;
           margin: 0;
        }
        
        p {
           font-size: ${window.screen.width <= 1000 ? '20px' : '30px'}; 
        }

        .button-box {
            width: 30%;
            height: 20px;
            font-size: 20px;
            margin: 0;
            padding: 0;
        }
    }
`;